'use client'

import { notifyClickAction } from '../actions/notify-click-action'
import { NotifyClickMutationVariables } from '../graphql/product/generated/graphql-types'

export default function useNotifyClick() {
  return (params: { variables: NotifyClickMutationVariables }) => notifyClickAction(params)
}
